import type { User } from "schemas/generated/user";

import * as React from "react";

type CurrentUserContext = {
  user: User | undefined;
  isAuthenticated: boolean;
  isLoading: boolean;
  isError: boolean;
};

export const CurrentUserContext = React.createContext<CurrentUserContext>({
  user: undefined,
  isAuthenticated: false,
  isLoading: false,
  isError: false,
});
